import React, { useMemo, useState } from 'react';
import DataTable from '../DataTable';
import Badge from '../common/Badge';
import Button from '../common/Button';
import StatCard from '../StatCard';
import { t } from '../../i18n';

const seedRows = [
  { id: 'cmp-1', proveedor: 'ConstruSolar SpA', requisito: 'Prevencion de delitos', estado: 'Cumple', vencimiento: '2026-10-10', responsable: 'Legal', criticidad: 'Media' },
  { id: 'cmp-2', proveedor: 'InfraPower Latam', requisito: 'Certificacion SST', estado: 'Por vencer', vencimiento: '2026-04-15', responsable: 'HSE', criticidad: 'Alta' },
  { id: 'cmp-3', proveedor: 'PowerStorage Consortium', requisito: 'Poliza RC', estado: 'No cumple', vencimiento: '2026-03-10', responsable: 'Contratos', criticidad: 'Alta' },
  { id: 'cmp-4', proveedor: 'EPC Andes', requisito: 'Anticorrupcion', estado: 'Cumple', vencimiento: '2027-01-20', responsable: 'Compliance', criticidad: 'Baja' }
];

const ESTADO_TONE = {
  'Cumple': 'success',
  'Por vencer': 'warning',
  'No cumple': 'danger'
};

const SuppliersComplianceMatrix = () => {
  const [statusFilter, setStatusFilter] = useState('Todos');
  const [rows, setRows] = useState(seedRows);

  const filtered = useMemo(() => {
    if (statusFilter === 'Todos') return rows;
    return rows.filter((row) => row.estado === statusFilter);
  }, [rows, statusFilter]);

  const kpi = useMemo(() => {
    return {
      total: rows.length,
      cumple: rows.filter((r) => r.estado === 'Cumple').length,
      alerta: rows.filter((r) => r.estado !== 'Cumple').length
    };
  }, [rows]);

  const columns = [
    { key: 'proveedor', label: t('Proveedor'), sortable: true },
    { key: 'requisito', label: t('Requisito'), sortable: true },
    {
      key: 'estado',
      label: t('Estado'),
      sortable: true,
      render: (value) => <Badge tone={ESTADO_TONE[value] || 'neutral'}>{t(value)}</Badge>
    },
    { key: 'vencimiento', label: t('Vencimiento'), sortable: true },
    { key: 'responsable', label: t('Responsable'), sortable: true },
    { key: 'criticidad', label: t('Criticidad'), sortable: true },
    {
      key: 'accion',
      label: t('Accion'),
      render: (_, row) => (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => setRows((prev) => prev.map((item) => item.id === row.id ? { ...item, estado: 'Cumple' } : item))}
        >{t('Regularizar')}</Button>
      )
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-neutral-900">{t('Matriz de Cumplimiento')}</h1>
          <p className="text-sm text-neutral-500">{t('Checklist legal, ambiental y de seguridad para proveedores criticos.')}</p>
        </div>
        <select
          value={statusFilter}
          onChange={(event) => setStatusFilter(event.target.value)}
          className="h-8 px-3 rounded border border-neutral-300 text-sm focus:outline-none focus:ring-1 focus:ring-brand-400 focus:border-brand-400"
        >
          <option>{t('Todos')}</option>
          <option>{t('Cumple')}</option>
          <option>{t('Por vencer')}</option>
          <option>{t('No cumple')}</option>
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard title={t('Total controles')} value={kpi.total} />
        <StatCard title={t('Cumple')} value={kpi.cumple} />
        <StatCard title={t('Con alerta')} value={kpi.alerta} />
      </div>

      <DataTable
        data={filtered}
        columns={columns}
        searchPlaceholder={t('Buscar proveedor o requisito...')}
      />
    </div>
  );
};

export default SuppliersComplianceMatrix;
